import {
  PbNewReturnReason,
  PbReturnReasonsCollection
} from '@itsrever/rever-api'
import { ReturnReason } from '@/domain/return-reasons'

export function toReturnReasons(
  collection: PbReturnReasonsCollection
): ReturnReason[] {
  return (
    collection.return_reasons?.map((reason) => ({
      parentReason: {
        reason: reason.parent_reason?.name ?? '',
        categoryIds: reason.parent_reason?.category_ids ?? [],
        hidden: reason.parent_reason?.hidden ?? false,
        mandatoryComment: reason.parent_reason?.mandatory_comment ?? false
      },
      subReasons:
        reason.available_reasons?.map((subReason) => {
          return {
            reason: subReason.name ?? '',
            categoryIds: subReason.category_ids ?? [],
            hidden: subReason.hidden ?? false,
            mandatoryComment: subReason.mandatory_comment ?? false
          }
        }) ?? []
    })) ?? []
  )
}

export function toBackendReasons(reasons: ReturnReason[]): PbNewReturnReason[] {
  return reasons
    .map((reason) => {
      let parentCategoryIds: string[] = reason.parentReason.categoryIds
      if (reason.subReasons.length > 0) {
        const childrenHasAll = reason.subReasons.some((sub) =>
          sub.categoryIds.includes('*')
        )
        if (childrenHasAll) parentCategoryIds = ['*']
        else
          parentCategoryIds = reason.subReasons
            .map((sub) => sub.categoryIds)
            .flat()
      }

      // SaveReturnReasons replaces the whole set, so every per-reason flag must
      // be echoed back or a dashboard save would reset it for all reasons.
      const parentReason: PbNewReturnReason = {
        name: reason.parentReason.reason,
        category_ids: parentCategoryIds,
        hidden: reason.parentReason.hidden,
        mandatory_comment: reason.parentReason.mandatoryComment
      }
      const subReasons: PbNewReturnReason[] = reason.subReasons.map(
        (subReason) => ({
          name: subReason.reason,
          category_ids: subReason.categoryIds,
          hidden: subReason.hidden,
          mandatory_comment: subReason.mandatoryComment
        })
      )
      return [parentReason, ...subReasons]
    })
    .flat()
}
